<template>
    <div class="boxTR mb-4 p-3 d-flex flex-column-reverse flex-md-row justify-content-between align-items-start align-items-md-center">
        <button v-if="showButton" type="button" class="font-base-links btn btn-vigo-1-500 rounded rounded-pill d-flex align-items-center white-space-nowrap">
            <plus_icon class="me-2"></plus_icon>
            Weitere Person versichern
        </button>
        <div class="mb-4 mb-md-0 ms-md-auto">
            <template v-if="isHinweistext">
                <strong>{{ gesamtbetrag }}</strong>
            </template>
            <template v-else>
                Monatlicher Gesamtbeitrag: <strong>{{ gesamtbetrag }}</strong> mtl.
            </template>
        </div>
    </div>    
</template>

<script setup>
import { computed } from 'vue';
import plus_icon from "../icons/plus_icon.vue";

const props = defineProps({
    gesamtbetrag: {
        type: String,
        default: '- €'
    },
    showButton: {
        type: Boolean,
        default: true
    }
})

const isHinweistext = computed(() => props.gesamtbetrag.startsWith('Bitte'))
</script>

<style scoped>
    .white-space-nowrap {
        white-space: nowrap !important;
        overflow-wrap: normal !important;
        word-break: normal !important;
        hyphens: none !important;
    }
</style>